// extracted by mini-css-extract-plugin
export default {"postBox":"style_postBox__HT1qm","title":"style_title__ictd2","content":"style_content__+aBUe","postFooter":"style_postFooter__R2Ck+"};